import React from "react";
import { withRouter, useHistory } from "react-router-dom";
import Main from "./main";
import { CompaniesStore } from "../../contexts";

function Companies(props) {
    const history = useHistory();
    if (props.companychanged || !props.currentcompany) history.push("/");

    return (
        <CompaniesStore>
            <Main {...props} />
        </CompaniesStore>
    );
}

export default withRouter(Companies);